circleLoader.controller('circleLoaderCtrl', [
    '$window',
    '$element',
    '$scope',
    function ($window, $element, $scope) {
        var self = this;

        self.strokeLength = 182;
        self.circle = $element.find('#moving');

        self.resetLoader = loaderFillAnimation;
        self.showCompletion = showCompletion;
        self.loaderFillAnimation = loaderFillAnimation;
        self.spinnerFillAnimation = spinnerFillAnimation;
        self.onDestroy = onDestroy;

        $scope.$on('$destroy', self.onDestroy);

        if ($window.angular.version.minor > 5) {
            self.$onInit = init;
        } else {
            init();
        }

        ////////////////////////

        function init() {
            self.duration = self.duration || 2000;
            self.size = self.size || 48;
            switch (self.type) {
                case 'percent-loader':
                    $scope.$watch('circleLoader.completion', function (nv) {
                        self.circle.css('stroke-dashoffset', self.strokeLength - (self.strokeLength / 100) * nv);
                    });
                    break;
                case 'loader':
                    self.loaderFillAnimation();
                    break;
                case 'spinner':
                /* falls through */
                default:
                    $element.addClass('m-spinner');
                    self.spinnerFillAnimation();
                    break;
            }
        }

        function showCompletion() {
            return $window.angular.isDefined(self.completion);
        }

        function loaderFillAnimation() {
            self.circle
                .stop(true, false)
                .css({ 'stroke-dashoffset': self.strokeLength })
                .animate({ 'stroke-dashoffset': 0 }, self.duration);
        }

        function spinnerFillAnimation() {
            self.circle.animate({ 'stroke-dashoffset': 136.5 }, 500, function () {
                self.circle.delay(300).animate({ 'stroke-dashoffset': 91 }, 500, function () {
                    self.circle.delay(300).animate({ 'stroke-dashoffset': 45.5 }, 500, function () {
                        self.circle.delay(300).animate({ 'stroke-dashoffset': 45.5 }, 500, function () {
                            self.circle.delay(300).animate({ 'stroke-dashoffset': 91 }, 500, function () {
                                self.circle.delay(300).animate({ 'stroke-dashoffset': 136.5 }, 500, function () {
                                    self.circle.delay(300).animate({ 'stroke-dashoffset': 172 }, 500, function () {
                                        if (typeof self.spinnerFillAnimation === 'function') {
                                            self.spinnerFillAnimation();
                                        }
                                    });
                                });
                            });
                        });
                    });
                });
            });
        }

        function onDestroy() {
            self.spinnerFillAnimation = null;
        }
    }
]);
